"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const react_1 = __importStar(require("react"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Button_1 = __importDefault(require("./Button"));
const ActionMenuButton = (0, react_1.forwardRef)((props, ref) => {
    const activeTheme = (0, react_native_paper_1.useTheme)();
    const NextepTheme = (0, ThemeContext_1.useTheme)();
    const { disabled = false, label, buttonType = "outline", buttonColor = NextepTheme.Primary, actionsList, menuContainerMaxHeight, menuContainerHeight, activeColor, menuStyle, menuItemStyle, menuItemTextStyle, titleNumberOfLines = 1 } = props;
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [inputLayout, setInputLayout] = (0, react_1.useState)({
        height: 0,
        width: 0
    });
    const onDismiss = () => {
        setVisible(false);
    };
    const showMenu = () => {
        setVisible(true);
    };
    const onLayout = (event) => {
        setInputLayout(event.nativeEvent.layout);
    };
    return ((0, jsx_runtime_1.jsx)(react_native_paper_1.Menu, { visible: visible, onDismiss: onDismiss, anchor: (0, jsx_runtime_1.jsx)(react_native_1.View, { onLayout: onLayout, children: (0, jsx_runtime_1.jsxs)(Button_1.default, { type: buttonType, color: buttonColor, disabled: disabled, accessibilityHint: props["aria-label"] ?? label, onPress: showMenu, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: buttonType == "solid" ? NextepTheme.White : disabled ? NextepTheme.TextDisabled : buttonColor, fontSize: 14, fontWeight: "500", marginHorizontal: 6 }, children: label }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: buttonType == "solid" ? NextepTheme.White : disabled ? NextepTheme.TextDisabled : buttonColor, icon: visible ? Theme_1.ICONS.Regular.ChevronUp : Theme_1.ICONS.Regular.ChevronDown, size: 14, style: { marginRight: 6 } })] }) }), contentStyle: { backgroundColor: NextepTheme.CardBackground }, theme: { animation: { scale: 0 } }, style: {
            flexDirection: 'row-reverse',
            position: 'relative',
            marginTop: inputLayout?.height + 6,
            ...menuStyle,
        }, children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { bounces: false, style: {
                maxWidth: 250,
                ...(menuContainerHeight ?
                    {
                        height: menuContainerHeight,
                    }
                    :
                        {
                            maxHeight: menuContainerMaxHeight || 350,
                        }),
            }, children: actionsList.filter(i => i).map((_item, _index) => ((0, jsx_runtime_1.jsx)(react_native_paper_1.List.Item, { titleNumberOfLines: titleNumberOfLines, disabled: _item.disabled, onPress: () => {
                    _item.onPress();
                    onDismiss();
                }, titleStyle: {
                    fontWeight: '400',
                    color: NextepTheme.Text,
                    fontSize: 14,
                    cursor: 'pointer',
                    pointerEvents: 'none',
                    ...(menuItemTextStyle),
                }, left: (props) => _item.icon &&
                    (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { ...props, color: _item.iconColor ?? NextepTheme.Text, icon: _item.icon, size: _item.iconSize ?? 16, style: { paddingVertical: 2, marginLeft: 12, marginRight: -6, cursor: 'pointer', ...(menuItemTextStyle) } }), right: (props) => _item.external &&
                    (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { ...props, color: _item.iconColor ?? NextepTheme.Text, icon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, size: (_item.iconSize ?? 16) - 6, style: { ...(menuItemTextStyle) } }), title: _item.label, containerStyle: {
                    alignItems: 'center'
                }, style: {
                    paddingVertical: 2,
                    flex: 1,
                    opacity: (_item.disabled ? 0.5 : 1),
                    ...menuItemStyle,
                } }, _index))) }) }));
});
exports.default = ActionMenuButton;
